import Alert from 'helpers/Alert';
import {SWRKeyEnum} from 'interfaces';
import {type MutableRefObject, useCallback} from 'react';
import backendCommunicator from 'services/backendCommunicator';
import useSWR from 'swr';
import {useGetNaturalComparator} from './useGetNaturalComparator';

const useGetEmptyCages = ({
  siteId,
  date,
  isMounted,
}: {
  siteId?: string;
  date: Date | null;
  isMounted: MutableRefObject<boolean>;
}) => {
  const naturalComparator = useGetNaturalComparator();
  const fetchEmptyCages = useCallback(
    async ([siteId, date]: [siteId: string, date: Date]) => {
      try {
        const response = await backendCommunicator.getEmptyCages(siteId, date);
        const data = response.data;
        return data.sort((a, b) => naturalComparator(a.name, b.name));
      } catch (error) {
        isMounted.current && Alert.error(error);
      }
    },
    [naturalComparator, isMounted],
  );

  const {data, error} = useSWR(siteId ? [siteId, date, SWRKeyEnum.GET_SITE_EMPTY_CAGES] : null, fetchEmptyCages);

  return {
    emptyCages: data,
    isLoading: !!siteId && !error && !data,
  };
};

export default useGetEmptyCages;
